import { styled } from "styled-components";
const DividerImpl = styled("hr")(({ theme }) => ({
  backgroundColor: theme.color.gray4,
  border: 0,
  height: 1,
  margin: 0,
  padding: 0,
  width: "100%"
}));
export {
  DividerImpl
};
